import React from 'react';
import Row from 'react-bootstrap/Row';
import Carousel from 'react-bootstrap/Carousel';
import { Link } from 'react-router-dom';
import withContext from "../../withContext";
import cross from './close.png';

class Galleryitem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            touchStart: null,
            touchEnd: null
        };
        this.isNavigating = false;
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchMove = this.handleTouchMove.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);
    }

    componentDidMount() {
        document.body.style.overflow = "hidden";
        window.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            document.body.style.overflow = "visible";
            sessionStorage.setItem('prevPath', window.location.pathname);
            this.props.history.push('/gallery');
        } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            e.stopPropagation();
            this.handlePrev();
        } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            e.stopPropagation();
            this.handleNext();
        }
    }

    handlePrev = () => {
        const { id } = this.props.match.params;
        const currentIndex = parseInt(id) - 1;
        const newIndex = currentIndex - 1;
        if (newIndex >= 0) {
            this.handleSlideChange(newIndex);
        }
    }

    handleNext = () => {
        const { id } = this.props.match.params;
        const galleryprops = this.getGalleryProps();
        const currentIndex = parseInt(id) - 1;
        const newIndex = currentIndex + 1;
        if (newIndex < galleryprops.items.length) {
            this.handleSlideChange(newIndex);
        }
    }

    handleTouchStart(e) {
        this.setState({ touchStart: e.targetTouches[0].clientX });
    }

    handleTouchMove(e) {
        this.setState({ touchEnd: e.targetTouches[0].clientX });
    }

    handleTouchEnd = () => {
        if (!this.state.touchStart || !this.state.touchEnd) return;
        
        const distance = this.state.touchStart - this.state.touchEnd;
        const minSwipeDistance = 50;
        
        if (distance > minSwipeDistance) {
            this.handleNext();
        } else if (distance < -minSwipeDistance) {
            this.handlePrev();
        }
        
        this.setState({ touchStart: null, touchEnd: null });
    }

    handleSlideChange = (selectedIndex) => {
        // Only navigate if index actually changed from URL
        const { id } = this.props.match.params;
        const currentIndex = parseInt(id) - 1;
        if (selectedIndex !== currentIndex && !this.isNavigating) {
            this.isNavigating = true;
            this.props.history.push(`/galleryitem/${selectedIndex + 1}`);
            // Reset flag after navigation completes
            setTimeout(() => {
                this.isNavigating = false;
            }, 100);
        }
    }

    importAll(r) {
        let images = {};
        r.keys().forEach((item) => {
            images[item.replace('./', '')] = r(item);
        });
        return images;
    }

    getGalleryProps() {
        const { id } = this.props.match.params;
        const arrayIndex = parseInt(id) ? parseInt(id) - 1 : 0;
        let galleryprops = this.props.location.about;

        if (galleryprops !== undefined) {
            localStorage.setItem("lastusedgalleryprops", JSON.stringify(galleryprops));
        } else {
            const cached = localStorage.getItem("lastusedgalleryprops");
            if (cached) {
                galleryprops = JSON.parse(cached);
            } else {
                const images = this.importAll(require.context('./GalleryPhotos', false, /\.(png|jpe?g|svg|jpg|JPG)$/));
                const imagevalues = Object.values(images);
                const galleryphotos = imagevalues.map(value => value.default);
                galleryprops = {
                    index: arrayIndex,
                    items: galleryphotos
                };
            }
        }
        return galleryprops;
    }

    render() {
        const { id } = this.props.match.params;
        const arrayIndex = parseInt(id) ? parseInt(id) - 1 : 0;
        const galleryprops = this.getGalleryProps();

        function handleclick() {
            document.body.style.overflow = "visible";
            // Store current path so Gallery knows we're coming from GalleryItem
            sessionStorage.setItem('prevPath', window.location.pathname);
        }

        return (
            <div 
                onTouchStart={this.handleTouchStart}
                onTouchMove={this.handleTouchMove}
                onTouchEnd={this.handleTouchEnd}
            >
                <Row className="justify-content-center mt-4 mb-4" style={{ paddingTop: '6rem' }}>
                    {galleryprops.items.map((item, index) => (
                        <div key={index} className="innerimg card-img m-2 card">
                            <img className="innerimg2 w-100 h-100" src={item} alt="Gallery item" />
                        </div>
                    ))}
                </Row>

                <Carousel
                    controls={true}
                    indicators={false}
                    interval={null}
                    activeIndex={arrayIndex}
                    onSelect={this.handleSlideChange}
                    className="GalleryBackground"
                    style={{ touchAction: 'pan-y' }}
                    wrap={false}
                    keyboard={false}
                >
                    {galleryprops.items.map((img, index) => (
                        <Carousel.Item key={index} className="GalleryItem">
                            <div className="glry">
                                <img className="glryimg" src={img} alt="Gallery slide" />

                                <div className="glrytext">
                                    <h5>{galleryprops.items.indexOf(img) + 1} of {galleryprops.items.length}</h5>
                                </div>
                            </div>
                        </Carousel.Item>
                    ))}
                </Carousel>

                <Link onClick={handleclick} to="/gallery">
                    <button
                        type="button"
                        className="LightboxClose"
                        aria-label="Close gallery view"
                    >
                        <img src={cross} alt="Close" />
                    </button>
                </Link>
            </div>
        );
    }
}

export default withContext(Galleryitem);